import React, { memo, useState } from 'react';
import { Table, TableBody, TableRow, TableCell, TableContainer, Paper, Chip } from '@mui/material';
import TableHeader from './TableHeader';
import { convertEpochMillisToDate, convertEpochMillisToDateTime } from '../../../utils/dateUtils';
import LockStatusPopup from './LockStatusPopup';
import { submitViewedNote } from '../../../actions/review';

const ApplicationsTable = ({
    data,
    onRowClick,
    sortConfig: { sortBy, sortDirection, onSort }
}) => {
    const renderStatusChip = (status) => {
        const statusColors = {
            APPROVED: 'success',
            PENDING: 'warning',
            REJECTED: 'error',
            default: 'default'
        };

        return <Chip
            sx={{ fontSize: '12px' }}
            label={status}
            color={statusColors[status] || statusColors.default} />;
    };

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [isLocked, setIsLocked] = useState(null);
    const [lockCode, setLockCode] = useState('');

    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupMessage('');
        setIsLocked(null);
        setLockCode('');
    };

    return (
        <TableContainer
            component={Paper}
            sx={{
                boxShadow: 'none', border: 'none',
                borderRadius: '8px'
            }}>
            <Table sx={{ size: 'small', border: 'none' }}>
                <TableHeader
                    onSort={onSort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                />
                <TableBody>
                    {data?.map((item) => (
                        <TableRow
                            key={item?.applicationNumber}
                            onClick={() => onRowClick(item, submitViewedNote, setIsPopupOpen, setPopupMessage, setIsLocked, setLockCode)}
                            sx={{
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: '#f5f5f5' },
                                '&:nth-of-type(even)': {
                                    backgroundColor: 'var(--row-bg-light)',
                                }
                            }}
                        >
                            <TableCell sx={{ padding: "6px 12px", fontSize: "0.85rem" }}>
                                {item?.applicationNumber}
                            </TableCell>

                            <TableCell sx={{ padding: "6px 12px", fontSize: "0.85rem" }}>
                                {item?.userId}
                            </TableCell>

                            <TableCell sx={{ padding: "6px 12px", fontSize: "0.85rem" }}>
                                {`${convertEpochMillisToDateTime(item?.submittedDate)}`}
                            </TableCell>

                            <TableCell sx={{ padding: "6px 12px", fontSize: "0.85rem" }}>
                                {item?.reviewerName}
                            </TableCell>

                            <TableCell sx={{ padding: "6px 12px", fontSize: "0.85rem" }}>
                                {renderStatusChip(item?.applicationStatus)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <LockStatusPopup
                isOpen={isPopupOpen}
                message={popupMessage}
                isLocked={isLocked}
                lockCode={lockCode}
                onClose={closePopup}
            />
        </TableContainer>
    );
};

export default memo(ApplicationsTable);